var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,3.75h30v22.5H0V3.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.75h30v22.5L0,3.75Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.574,10.287c-.222.286-.746-.288-1.374-.301s-1.073.602-1.256.811c-.183.209-.772,1.309-.759,1.426s.366-.327.497-.406c.013.157-.144.34-.105.393s.458-.314.602-.327c.039.105-.079.209-.039.366.052.052.288-.262.445-.327.026.118-.144.34-.052.484.065.013.458-.445.589-.497s-.065.432,0,.471c.118-.079.484-.497.602-.55.118-.052-.013.536.039.536.144-.105.51-.602.55-.68.039-.079-.039.759.366,1.204.406.445,1.021.955,1.086.955.079-.144-.026-.445.039-.432.183.196.523.484.602.484s-.052-.314.052-.314c.209.196.811.968,1.989,1.322-.079-.222-.249-.419-.262-.523.079.013.353.144.406.131.052-.013-.576-.785-.537-.89.144-.013.209.079.262.013-.065-.105-.615-.72-.615-.864s.17.026.222,0-.209-.576-.157-.641.628.353.772.353.039-.51.105-.537c.065-.026.55.275.654.275.105,0,.092-.222.131-.196.039.026,1.178,1.165.785,2.499-.393.955-1.178,1.466-2.329,1.047.065.105.68.615,1.348.432s1.479-.707,1.387-2.015c-.092-1.309-.523-1.492-.589-1.688-.065-.196.105.052.249.105.144.052-.026-.275-.065-.419-.039-.144.432.301.55.34s-.275-1.073-.393-1.152.118.026.196.052c.079.026-.72-1.217-.89-1.217s.144-.065.236-.065-.916-.811-1.086-.811.366-.209.419-.222c.092.013-1.165-.667-2.29.013-.065-.052.53-.464.55-.641.007-.046-.196-.144-.209-.196s.314-.209.327-.327c-.079-.105-.222-.065-.301-.092-.02-.098.275-.34.249-.445-.02-.059-.236-.079-.288-.039-.052.039.137-.275.105-.366-.026-.039-.131-.013-.236.013-.065-.013.34-.576.262-.654-.079-.079-1.178.576-1.583,1.309-.406.733-.092,1.322-.144,1.57-.052.249-.118.497-.288.497s-.563-.262-.694-.393-.157-.222-.34-.275c-.183-.052-.602.105-.759.118s-.772-.118-.811-.079c-.039.039.602.275.746.353.144.078.157.183.262.249.102.067,1.084.355.77.76h0ZM22.408,12.132c.314.314,2.434,1.727,2.434,3.455s-1.544,1.675-1.989,1.623c.497.419,2.382.34,2.382-1.623,0-1.727-2.434-3.455-2.748-3.612-.315-.157-.393-.157-.079.157Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.5,10.65l.353,1.015,1.074.022-.856.649.311,1.028-.882-.614-.882.613.311-1.028-.856-.649,1.074-.022.353-1.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M4.2,15.15l.353,1.015,1.074.022-.856.649.311,1.028-.882-.614-.882.613.311-1.028-.856-.649,1.074-.022.353-1.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M7.5,21.15l.353,1.015,1.074.022-.856.649.311,1.028-.882-.614-.882.613.311-1.028-.856-.649,1.074-.022.353-1.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M10.5,14.85l.353,1.015,1.074.022-.856.649.311,1.028-.882-.614-.882.613.311-1.028-.856-.649,1.074-.022.353-1.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M9,18.6l.176.507.537.011-.428.324.156.514-.441-.306-.441.307.156-.514-.428-.324.537-.011.176-.508Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.1ab5c31c5a837ac84b800afc6245af19.svg";
export { ForwardRef as ReactComponent };